/**
 * Centralized Logger utility for Tourminator.
 * Standardizes log formats to make debugging easier, especially for remote logs.
 */

const LOG_LEVELS = {
    DEBUG: 'DEBUG',
    INFO: 'INFO',
    WARN: 'WARN',
    ERROR: 'ERROR',
};

// For native debugging: store last 100 logs in memory
const logBuffer = [];
const MAX_LOGS = 100;

const addToBuffer = (level, module, message, data) => {
    const logEntry = {
        timestamp: new Date().toISOString(),
        level,
        module,
        message,
        data
    };
    logBuffer.unshift(logEntry);
    if (logBuffer.length > MAX_LOGS) {
        logBuffer.pop();
    }
};

const formatMessage = (level, module, message, data) => {
    const timestamp = new Date().toISOString();
    const dataString = data ? ` | Data: ${JSON.stringify(data)}` : '';
    return `[${timestamp}] [${level}] [${module}] ${message}${dataString}`;
};

const Logger = {
    debug: (module, message, data) => {
        addToBuffer(LOG_LEVELS.DEBUG, module, message, data);
        if (process.env.NODE_ENV !== 'production') {
            console.debug(formatMessage(LOG_LEVELS.DEBUG, module, message, data));
        }
    },
    info: (module, message, data) => {
        addToBuffer(LOG_LEVELS.INFO, module, message, data);
        console.info(formatMessage(LOG_LEVELS.INFO, module, message, data));
    },
    warn: (module, message, data) => {
        addToBuffer(LOG_LEVELS.WARN, module, message, data);
        console.warn(formatMessage(LOG_LEVELS.WARN, module, message, data));
    },
    error: (module, message, error, data) => {
        const errorDetails = error ? {
            message: error.message,
            stack: error.stack,
            code: error.code,
            ...error
        } : null;
        addToBuffer(LOG_LEVELS.ERROR, module, message, { ...data, error: errorDetails });
        console.error(formatMessage(LOG_LEVELS.ERROR, module, message, { ...data, error: errorDetails }));
    },
    getLogs: () => [...logBuffer],
    clearLogs: () => { logBuffer.length = 0; }
};

export default Logger;

